import emptyFunction from 'react-utils/emptyFunction';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import { APP_PATHS } from 'EmailData/constants/app';
import CompareEmailsUpgradeButton from 'EmailComponents/compareEmails/CompareEmailsUpgradeButton';
import { trackCompareToolInteraction } from 'EmailData/utils/tracking';
import { useCallback } from 'react';
import { navigateTo } from 'EmailData/utils/url';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CompareEmailsButton({
  selectedTab,
  updateQueryAndPathParams,
  setComparisonToolReturnLocation = emptyFunction,
  isStarter,
  isFree,
  tracker,
  help
}) {
  const onClickCompareEmails = useCallback(() => {
    trackCompareToolInteraction(tracker, {
      action: 'header-button-entry'
    });
    if (selectedTab === APP_PATHS.MANAGE_TAB) {
      navigateTo(ContentRoutes.emailCompare());
      return;
    }
    const searchParams = {};
    if (selectedTab === APP_PATHS.HEALTH_TAB) {
      searchParams.redirectTo = selectedTab;
    }
    setComparisonToolReturnLocation(selectedTab);
    updateQueryAndPathParams(searchParams, {}, emptyFunction, APP_PATHS.COMPARISON_TAB, true);
  }, [selectedTab, tracker, updateQueryAndPathParams, setComparisonToolReturnLocation]);
  if (isFree) {
    return null;
  } else if (isStarter) {
    return /*#__PURE__*/_jsx(CompareEmailsUpgradeButton, {
      use: "secondary",
      help: help
    });
  }
  return /*#__PURE__*/_jsxs(UIButton, {
    "data-test-id": "compare-emails-button",
    onClick: onClickCompareEmails,
    size: "sm",
    use: "secondary",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "EmailComponents.header.compareEmails"
    }), help]
  });
}
export default CompareEmailsButton;